import './page';
import { Player } from './player';
import { urlToGame } from './pack';
const player = new Player(urlToGame, false);
